module.exports = __webpack_public_path__ + "img/pending-approval.5945d6f0.svg";